import { baseClient } from "./baseRequest";

export type FirmwareKlydos = {
  id: string;
  // Display name. Only set directly in MongoDB — never editable from the UI.
  name: string;
  // Optional link to a device firmware. Nullable, managed directly in Mongo.
  firmwareId: string | null;
  klydosIds: string[];
  // When true the klydo list is frozen (read-only). Only flipped in Mongo.
  sealed: boolean;
  createdAt: string;
  updatedAt: string;
};

export type CreateFirmwareKlydosPayload = {
  klydosIds: string[];
  firmwareId?: string | null;
};

export type FirmwareKlydosApiClient = {
  getAllFirmwareKlydos: () => Promise<FirmwareKlydos[]>;
  createFirmwareKlydos: (
    payload: CreateFirmwareKlydosPayload,
  ) => Promise<FirmwareKlydos>;
  updateFirmwareKlydosKlydos: (
    id: string,
    klydosIds: string[],
  ) => Promise<FirmwareKlydos>;
  removeFirmwareKlydos: (id: string) => Promise<void>;
};

const firmwareKlydosClient: FirmwareKlydosApiClient = {
  getAllFirmwareKlydos: async () => {
    return baseClient.get<FirmwareKlydos[]>({
      url: "/firmware-klydos",
    });
  },
  createFirmwareKlydos: async (payload) => {
    return baseClient.post<FirmwareKlydos>({
      url: "/firmware-klydos",
      body: payload,
    });
  },
  updateFirmwareKlydosKlydos: async (id, klydosIds) => {
    return baseClient.put<FirmwareKlydos>({
      url: `/firmware-klydos/${id}`,
      body: { klydosIds },
    });
  },
  removeFirmwareKlydos: async (id) => {
    return baseClient.delete({
      url: `/firmware-klydos/${id}`,
    });
  },
};

export default firmwareKlydosClient;
